


















import groupRow from './groupRow.vue'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
// 12个一组
// height:5rem
const ROW_HEIGHT = 5
const DELAY = 2222
@Component({
  components: {
    groupRow,
  },
})
export default class Group extends Vue {
  @Prop({ default: [] })
  organizers
  @Prop() type: any
  computedOrganizers: any = []
  currentOffset: number = 0
  setTimeoutId: any = 0
  totleHeight: number = 0
  created() {
    this.init(this.organizers)
  }

  @Watch('organizers')
  onOrganizersChanged(newVal) {
    this.init(newVal)
  }

  init(newVal) {
    window.clearTimeout(this.setTimeoutId)
    this.currentOffset = 0
    if (!newVal.length || newVal.length <= 2) {
      this.computedOrganizers = newVal || []
      return
    }
    let computedOrganizers =
      newVal.length % 2 === 0 ? newVal : newVal.concat(newVal)
    this.computedOrganizers = [...computedOrganizers, ...newVal.slice(0, 2)]
    this.totleHeight = this.computedOrganizers.length * ROW_HEIGHT
    setTimeout(() => {
      this.transfromY()
    }, DELAY * 2)
  }
  transfromY() {
    let currentOffset = (this.currentOffset += 2 * ROW_HEIGHT)
    if (currentOffset >= this.totleHeight) {
      this.currentOffset = 0
    } else {
      this.currentOffset = currentOffset
    }
    let delay =
      this.currentOffset === 0 ||
      this.currentOffset === this.totleHeight - 2 * ROW_HEIGHT
        ? DELAY
        : DELAY * 2
    this.setTimeoutId = setTimeout(() => {
      this.transfromY()
    }, delay)
  }
  beforeDestory() {
    window.clearTimeout(this.setTimeoutId)
  }
}
